/**
 * Locale-aware language label for a BCP-47 / ISO 639-1 code.
 * Falls back to the raw code when `Intl.DisplayNames` is unavailable or the
 * code is unknown.
 */
export function languageDisplayName(code: string, locale: string): string {
  const trimmed = code.trim()
  if (trimmed.length === 0) return code
  try {
    const display = new Intl.DisplayNames([locale], { type: "language" })
    return display.of(trimmed) ?? trimmed
  } catch {
    return trimmed
  }
}

/**
 * Duration as `m:ss` (unpadded minutes). Used by the live language-switch
 * pill so "heard for 3:40" matches the mockup; the recording timer itself
 * stays on zero-padded `formatClock`.
 */
export function formatDurationClock(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00"
  const total = Math.floor(seconds)
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${m}:${s.toString().padStart(2, "0")}`
}
